export const contents = {
    'display': {
        'ko': {
            'newProduct': '지금 보는 상품',
            'newProductCount': '새로운 상품 +',
        },
        'en': {
            'newProduct': 'New Product',
            'newProductCount': 'New Product +',
        }
    },
    'carousel': {
        'ko': {
            'review': '리뷰',
            'new': '신규',
            'priceUnit': '₩',
        },
        'en': {
            'review': 'Review',
            'new': 'New',
            'priceUnit': '$',
        }
    },
    'chatInput': {
        'ko': {
            'placeholder': '무엇이든 물어보세요',
        },
        'en': {
            'placeholder': 'Ask me anything',
        }
    },
    'message': {
        'ko': {
            'networkError': '답변 중 오류가 발생했어요. 하단 초기화 버튼을 누르고, 잠시 뒤에 다시 시도해주세요.',
            'errorPage': '젠투 점원이 잠시 자리를 비웠어요. \n금방 돌아올게요!',
            'refresh': '새로고침',
        },
        'en': {
            'networkError': 'An error occurred while answering. Please click the reset button at the bottom and try again later.',
            'errorPage': 'The Gentoo assistant is taking a break.\nWe will be back soon!',
            'refresh': 'Refresh',
        }
    }
}